export default [
  {
    text: 'auditing.table.action',
    value: 'action',
  },
  {
    text: 'auditing.table.message',
    value: 'message',
  },
  {
    text: 'auditing.table.target',
    value: 'target',
    type: 'slot',
  },
  {
    text: 'auditing.table.actor',
    value: 'actor',
    type: 'slot',
  },
  {
    text: 'auditing.table.venue',
    value: 'venue',
    type: 'slot',
  },
  {
    text: 'auditing.table.customerGroup',
    value: 'customerGroup',
  },
  {
    text: 'auditing.table.changes',
    value: 'changes',
  },
  {
    text: 'auditing.table.createdAt',
    value: 'createdAt',
    type: 'date',
    format: 'DD.MM.YYYY HH:mm',
  },
];
